export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12084.c2dae8fa.jpg";